"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _luxon = require("luxon");

var _DateTimeHelper = _interopRequireDefault(require("./DateTimeHelper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CalendarHelper = {
  // Returns a date object in the browser's time zone for use on react-day-picker
  getCalendarToday: function getCalendarToday(timeZone) {
    return _DateTimeHelper["default"].changeTz(_luxon.DateTime.local().setZone(timeZone), _luxon.DateTime.local().zoneName).toJSDate();
  },
  getMerchantMonth: function getMerchantMonth(timeZone) {
    return _DateTimeHelper["default"].changeTz(_luxon.DateTime.local().setZone(timeZone), _luxon.DateTime.local().zoneName).startOf('month');
  }
};
var _default = CalendarHelper;
exports["default"] = _default;